import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface ShipmentBranchRequestParams {
  Customerkey: number;
}

export const getShipmentBranchListAPI = (params: ShipmentBranchRequestParams) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentBranches`,
    method: 'get',
    params,
  });
};

export type ShipmentBranchResponse = {
  branchKey: number;
  branchDesc: string;
  currencyCode: string;
}[];

export const fetchShipmentBranchList = async (params: ShipmentBranchRequestParams): Promise<ShipmentBranchResponse> => {
  const response: AxiosResponse<ShipmentBranchResponse> = await getShipmentBranchListAPI(params);
  return response.data;
};
